import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { UserSetting } from '@thiememeulenhoff/types';
import { UserSettingEndpointService } from './user-setting.endpoint.service';

@Service()
export class UserSettingService {
  readonly #http = inject(HttpClient);

  readonly #endpoints = inject(UserSettingEndpointService);

  fetchUserSettings() {
    const endpoint = this.#endpoints.getUserSettings();

    return this.#http.get<Array<UserSetting>>(endpoint);
  }

  fetchUserSettingByKey(key: string) {
    const endpoint = this.#endpoints.getUserSettingByKey(key);

    return this.#http.get<UserSetting | null | undefined>(endpoint);
  }

  createUserSetting(setting: UserSetting) {
    const endpoint = this.#endpoints.createSetting();

    return this.#http.post<UserSetting>(endpoint, setting);
  }

  deleteUserSetting(key: string) {
    const endpoint = this.#endpoints.deleteSetting(key);

    return this.#http.delete<UserSetting>(endpoint);
  }

  getUserSetting(key: string) {
    const endpoint = this.#endpoints.getSetting(key);

    return this.#http.get<UserSetting | null>(endpoint);
  }
}
